import React from 'react';

export type BadgeVariant =
  | 'incomplete'
  | 'payment-required'
  | 'import-completed'
  | 'completed'
  | 'in-progress'
  | 'pending'
  | 'errored'
  | 'neutral';

const BADGE_LABELS: Record<BadgeVariant, string> = {
  incomplete: 'Incomplete',
  'payment-required': 'Payment Required',
  'import-completed': 'Import Completed',
  completed: 'Completed',
  'in-progress': 'In Progress',
  pending: 'Pending',
  errored: 'Errored',
  neutral: 'Status',
};

// `label` overrides the default variant label - used when rendering a real status string whose
// wording should show through (e.g. "Awaiting Responses") while the variant only drives color.
export default function StatusBadge({
  variant,
  label,
  className,
}: {
  variant: BadgeVariant;
  label?: string;
  className?: string;
}) {
  return (
    <span
      className={`dash-badge dash-badge--${variant} inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-[11px] font-semibold uppercase${className ? ` ${className}` : ''}`}
    >
      <span className="dash-badge__dot h-[5px] w-[5px] flex-shrink-0 rounded-full" />
      {label ?? BADGE_LABELS[variant]}
    </span>
  );
}
